module.exports = __webpack_public_path__ + "img/m-banner-csrrksao-ko-KR.e8eaf239.jpg";